import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { RiTwitterXFill } from "react-icons/ri";
import {
  AppStoreBrand,
  GooglePlayBrand,
  WebmotorsV2Brand,
  WebmotorsV3Brand,
} from "../../../elements";
import { mountWithLkid } from "../../../support";
import { useFooter } from "../hooks";
import styles from "./footer-fixed.module.css";

export function FooterFixed() {
  const { links, isExpanded, getLinkTarget } = useFooter();

  return (
    <div className={styles.FooterFixed}>
      <div className={`${styles.FooterColumn} ${styles.MobileColumn}`}>
        <div className={styles.BrandTable}>
          <div className={styles.BrandColumnMobile}>
            <WebmotorsV2Brand />
          </div>
          <div className={styles.BrandColumn}>
            <WebmotorsV3Brand />
          </div>
        </div>

        <ul className={styles.Social}>
          <li>
            <a
              data-testid={links.SOCIAL.LINKEDIN.testId}
              href={links.SOCIAL.LINKEDIN.href}
              className={styles.SocialLink}
              id={links.SOCIAL.LINKEDIN.id}
              {...getLinkTarget(links.SOCIAL.LINKEDIN.href)}
              aria-label={links.SOCIAL.LINKEDIN.text}
            >
              <FaLinkedinIn />
            </a>
          </li>
          <li>
            <a
              data-testid={links.SOCIAL.FACEBOOK.testId}
              href={links.SOCIAL.FACEBOOK.href}
              className={styles.SocialLink}
              id={links.SOCIAL.FACEBOOK.id}
              {...getLinkTarget(links.SOCIAL.FACEBOOK.href)}
              aria-label={links.SOCIAL.FACEBOOK.text}
            >
              <FaFacebookF />
            </a>
          </li>
          <li>
            <a
              data-testid={links.SOCIAL.INSTAGRAM.testId}
              href={links.SOCIAL.INSTAGRAM.href}
              className={styles.SocialLink}
              id={links.SOCIAL.INSTAGRAM.id}
              {...getLinkTarget(links.SOCIAL.INSTAGRAM.href)}
              aria-label={links.SOCIAL.INSTAGRAM.text}
            >
              <FaInstagram />
            </a>
          </li>
          <li>
            <a
              data-testid={links.SOCIAL.TIKTOK.testId}
              href={links.SOCIAL.TIKTOK.href}
              className={styles.SocialLink}
              id={links.SOCIAL.TIKTOK.id}
              {...getLinkTarget(links.SOCIAL.TIKTOK.href)}
              aria-label={links.SOCIAL.TIKTOK.text}
            >
              <FaTiktok />
            </a>
          </li>
          <li>
            <a
              data-testid={links.SOCIAL.X.testId}
              href={links.SOCIAL.X.href}
              className={styles.SocialLink}
              id={links.SOCIAL.X.id}
              {...getLinkTarget(links.SOCIAL.X.href)}
              aria-label={links.SOCIAL.X.text}
            >
              <RiTwitterXFill />
            </a>
          </li>
          <li>
            <a
              data-testid={links.SOCIAL.YOUTUBE.testId}
              href={links.SOCIAL.YOUTUBE.href}
              className={styles.SocialLink}
              id={links.SOCIAL.YOUTUBE.id}
              {...getLinkTarget(links.SOCIAL.YOUTUBE.href)}
              aria-label={links.SOCIAL.YOUTUBE.text}
            >
              <FaYoutube />
            </a>
          </li>
        </ul>
      </div>

      {!isExpanded && (
        <div className={`${styles.FooterColumn} ${styles.LinksContainer}`}>
          <a
            className={styles.Link}
            href={mountWithLkid(links.HELP.YOU)}
            {...getLinkTarget(mountWithLkid(links.HELP.YOU))}
          >
            Ajuda
          </a>
          <a
            className={styles.Link}
            href={mountWithLkid(links.HELP.WORK_WITH_US)}
            {...getLinkTarget(mountWithLkid(links.HELP.WORK_WITH_US))}
          >
            Trabalhe com a gente
          </a>
          <a
            className={`${styles.Link} ${styles.NoWhiteSpace}`}
            href={mountWithLkid(links.INSTITUTIONAL.PRIVACY)}
            {...getLinkTarget(mountWithLkid(links.INSTITUTIONAL.PRIVACY))}
          >
            Termos de uso e Política de privacidade
          </a>
        </div>
      )}

      <div className={`${styles.FooterColumn} ${styles.StoresContainer}`}>
        <strong className={styles.StoresTitle}>Baixe nosso App</strong>
        <div className={styles.StoresBadges}>
          <a
            href="https://bnxk.adj.st/?adj_t=1f4554og&adj_campaign=Footer&adj_engagement_type=fallback_click&adj_fallback=https%3A%2F%2Fwww.webmotors.com.br%2F&adj_redirect_macos=https%3A%2F%2Fwww.webmotors.com.br%2F&lkid=2524"
            {...getLinkTarget(
              "https://bnxk.adj.st/?adj_t=1f4554og&adj_campaign=Footer&adj_engagement_type=fallback_click&adj_fallback=https%3A%2F%2Fwww.webmotors.com.br%2F&adj_redirect_macos=https%3A%2F%2Fwww.webmotors.com.br%2F&lkid=2524"
            )}
            aria-label="Baixe nosso App no Google Play"
          >
            <GooglePlayBrand />
          </a>
          <a
            href="https://bnxk.adj.st?adj_t=1f4554og&adj_campaign=Footer&adj_engagement_type=fallback_click&adj_fallback=https%3A%2F%2Fwww.webmotors.com.br%2F&adj_redirect_macos=https%3A%2F%2Fwww.webmotors.com.br%2F&lkid=2525"
            {...getLinkTarget(
              "https://bnxk.adj.st?adj_t=1f4554og&adj_campaign=Footer&adj_engagement_type=fallback_click&adj_fallback=https%3A%2F%2Fwww.webmotors.com.br%2F&adj_redirect_macos=https%3A%2F%2Fwww.webmotors.com.br%2F&lkid=2525"
            )}
            aria-label="Baixe nosso App na App Store"
          >
            <AppStoreBrand />
          </a>
        </div>
      </div>
    </div>
  );
}
